var _excluded = ["id", "bundle", "items", "showMore", "priceInfo", "hasBorderRadiusOnMobile"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { loaderAtmSizeSpaces } from "../../atoms/LoaderAtm";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../FlexContainerOrg";
import MobileGutterDestroyerOrg from "../MobileGutterDestroyerOrg";
import PushOrg from "../PushOrg";
var Container = styled.div.withConfig({
  componentId: "sc-seabe5-0"
})(function (_ref) {
  var $hasBundle = _ref.$hasBundle,
    $hasBorderRadiusOnMobile = _ref.$hasBorderRadiusOnMobile,
    theme = _ref.theme;
  return css(["", " ", "{overflow:hidden;border-radius:", ";}", ""], $hasBorderRadiusOnMobile ? css(["overflow:hidden;border-radius:", ";"], getBorderRadius(theme, "large")) : null, breakpoint("medium"), getBorderRadius(theme, "large"), !$hasBundle ? css(["box-shadow:", ";> *{border-bottom:", " solid ", ";&:last-child{border-bottom:0;}}"], getBoxShadow(theme, "tiny"), unit(2), getBorderColor(theme, "backgroundLight", "low")) : null);
});
var ShowMore = styled(FlexContainerOrg).withConfig({
  componentId: "sc-seabe5-1"
})(["min-height:", ";margin-top:", ";"], space(loaderAtmSizeSpaces.tiny), space(2));
var PriceDescription = styled(TextAtm).withConfig({
  componentId: "sc-seabe5-2"
})(["text-align:center;", "{text-align:right;}"], breakpoint("medium"));
function DomainSearchResultItemsOrg(_ref2) {
  var id = _ref2.id,
    bundle = _ref2.bundle,
    items = _ref2.items,
    showMore = _ref2.showMore,
    priceInfo = _ref2.priceInfo,
    hasBorderRadiusOnMobile = _ref2.hasBorderRadiusOnMobile,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var priceDescription = /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1
  }, /*#__PURE__*/React.createElement(PriceDescription, {
    typography: "nano1",
    emphasis: "medium"
  }, priceInfo));
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id
  }, restProps), /*#__PURE__*/React.createElement(MobileGutterDestroyerOrg, null, bundle ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 3
  }, /*#__PURE__*/React.createElement(Container, {
    $hasBundle: !!bundle,
    $hasBorderRadiusOnMobile: hasBorderRadiusOnMobile
  }, bundle), priceInfo ? priceDescription : null) : null, /*#__PURE__*/React.createElement(Container, {
    $hasBorderRadiusOnMobile: hasBorderRadiusOnMobile
  }, items), priceInfo ? priceDescription : null, showMore ? /*#__PURE__*/React.createElement(ShowMore, {
    justifyContent: "center"
  }, showMore) : null));
}
export default DomainSearchResultItemsOrg;